import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookiesService } from '../../../../../services/cookies';
import { StorageService } from '../../../../../services/storage';
import { StorageKeysEnum } from '../../../../constants';
import { CookieSettingsModalComponent } from '../components/cookie-settings-modal.component';
import { CookiePreferences } from '../models/cookie-preferences.model';

@Injectable()
export class CookieBannerFacade {
  private readonly cookies = inject(CookiesService);
  private readonly storage = inject(StorageService);
  private readonly modal = inject(NgbModal);

  getCurrentPreferences(): CookiePreferences | null {
    return this.storage.getItem<CookiePreferences>(StorageKeysEnum.COOKIES_CONFIG);
  }

  acceptAll(): void {
    const preferences: CookiePreferences = { all: true };
    this.saveAndNotify(preferences);
  }

  saveCustomPreferences(customPreferences: Partial<CookiePreferences>): void {
    const preferences: CookiePreferences = { all: false, ...customPreferences };
    this.saveAndNotify(preferences);
  }

  openConfigurationModal(): void {
    const modalRef = this.modal.open(CookieSettingsModalComponent, {
      backdrop: 'static',
      centered: true,
      fullscreen: 'sm',
      keyboard: false,
      scrollable: true,
      size: 'lg',
    });

    modalRef.componentInstance.savedPreferences = this.getCurrentPreferences();

    modalRef.result.then((resolvedPreferences: CookiePreferences) => {
      if (resolvedPreferences) this.saveCustomPreferences(resolvedPreferences);
    });
  }

  private saveAndNotify(preferences: CookiePreferences): void {
    this.storage.setItem<CookiePreferences>(StorageKeysEnum.COOKIES_CONFIG, preferences);
    this.cookies.setCookiePreferences(preferences);
  }
}
